module.exports = __webpack_public_path__ + "img/ice3.157cee98.png";